import Fountain from './element/Fountain';
import VideoTexture from './element/video';
const store = {
    fountain: new Fountain(),
    events: new Map(),
    _isSmooth: true,
    _preRenderTime: 0,
    modelLoaded: false,
    loadingOctree: false,
    mode: 'sandTable',
    get isSmooth() {
        return this._isSmooth;
    },
    set isSmooth(val) {
        this._isSmooth = val;
        const fns = this.events.get('smooth-change');
        fns &&
            fns.forEach((fn) => {
                fn(val);
            });
        if (val && fns)
            this.events.delete('smooth-change');
    },
    get preRenderTime() {
        return this._preRenderTime;
    },
    set preRenderTime(val) {
        this._preRenderTime = val;
    },
    onSmoothChange(cb) {
        if (!this.scene) {
            // eslint-disable-next-line standard/no-callback-literal
            cb(true);
            return;
        }
        setTimeout(() => {
            if (!this.isSmooth)
                this.events.set('smooth-change', [cb]);
            else
                cb(this.isSmooth);
        }, 100);
    },
    onWeatherMounted(cb) {
        if (this.weather)
            return cb();
        this.on('init-weather', cb);
    },
    onOctreeLoaded(cb) {
        this.on('octree-loaded', cb);
    },
    onGltfUpdate(cb) {
        this.on('init-gltf', cb);
    },
    initVideo(url) {
        if (!url)
            return;
        const mesh = this.scene?.getObjectByName('video-mesh');
        const texture = new VideoTexture(url);
        if (Array.isArray(mesh.material)) {
            mesh.material.forEach((e) => {
                const material = e;
                material.map = material.emissiveMap = texture;
            });
        }
        else {
            const material = mesh.material;
            material.map = material.emissiveMap = texture;
        }
    },
    emit(type, ...rest) {
        const fns = this.events.get(type);
        fns &&
            fns.forEach((fn) => {
                fn(...rest);
            });
    },
    on(type, cb) {
        const event = this.events.get(type);
        if (event) {
            event.push(cb);
            return;
        }
        this.events.set(type, [cb]);
    },
    off(type, cb = undefined) {
        const events = this.events.get(type);
        if (!cb) {
            this.events.delete(type);
            return;
        }
        if (events?.includes(cb)) {
            const index = events.findIndex((e) => e === cb);
            events.splice(index, 1);
        }
    },
    clear() {
        this.worldOctree = undefined;
    }
};
const handle = {
    get(target, key) {
        return target[key];
    },
    set(target, key, value) {
        // if (typeof value === 'object' && value !== null) {
        // 防止vue监听
        // Object.defineProperty(value, '__ob__', {
        //   value: null,
        //   configurable: false,
        //   enumerable: false,
        //   writable: false,
        // });
        // }
        target[key] = value;
        return true;
    },
};
const storeProxy = new Proxy(store, handle);
export default storeProxy;
